import type { TSoilIrrigationActivityScope } from 'stores/detailsPanelStore/detailsPanelStore'

// every available device gets a row in the Water Events strip, empty when it has no events in the date range.
// The zone view also keeps a row for any other device with events, such as a scheduled one; the probe view shows only the devices at the probe
export const getEmitterDataForRows = <TEvent>({
  availableEmitters,
  emitterData,
  irrigationActivityScope,
}: {
  availableEmitters: string[]
  emitterData: { [irrigationZoneEmitterId: string]: TEvent[] }
  irrigationActivityScope: TSoilIrrigationActivityScope
}) => {
  const emptyRows = Object.fromEntries(
    availableEmitters.map((irrigationZoneEmitterId): [string, TEvent[]] => [irrigationZoneEmitterId, []]),
  )

  const emitterDataToShow =
    irrigationActivityScope === 'PROBE'
      ? Object.fromEntries(
          Object.entries(emitterData).filter(([irrigationZoneEmitterId]) =>
            availableEmitters.includes(irrigationZoneEmitterId),
          ),
        )
      : emitterData

  return { ...emptyRows, ...emitterDataToShow }
}
